import {
	ActivityGradientOutline,
	CalendarGradientOutline,
	LightningGradientFilled,
	MoonZzz,
	NotificationGradientOutline,
} from '@calm-web/icons';

import messages from './messages';
import { Item, Section } from './Retention/types';

export const featuresValueProps: Item[] = [
	{
		icon: CalendarGradientOutline,
		title: messages.quickMeditationTitle,
		copy: messages.quickMeditationDescription,
	},
	{
		icon: MoonZzz,
		title: messages.sleepTitle,
		copy: messages.sleepDescription,
	},
	{
		icon: ActivityGradientOutline,
		title: messages.taptivitiesTitle,
		copy: messages.taptivitiesDescription,
	},
];

export const efficacyValueProps: Item[] = [
	{
		icon: LightningGradientFilled,
		title: messages.tuneIntoYourselfTitle,
		copy: messages.tuneIntoYourselfDescription,
	},
	{
		icon: CalendarGradientOutline,
		title: messages.trackProgressTitle,
		copy: messages.trackProgressDescription,
	},
	{
		icon: NotificationGradientOutline,
		title: messages.notificationsTitle,
		copy: messages.notificationsDescription,
	},
];

export const goalBasedContentValueProps: Record<string, Section> = {
	sleep: {
		title: messages.sleepTab,
		navigateTo: '/app/sleep',
		slides: [
			{
				contentTitle: messages.sleepSlide1Title,
				contentSubheading: messages.sleepSlide1Narrator,
				contentUrl: '/app/player/xd0n9CHz8h',
				imageUrl: '/_n/images/sleep-content/crossing-ireland-by-train.webp',
			},
			{
				contentTitle: messages.sleepSlide2Title,
				contentSubheading: messages.sleepSlide2Narrator,
				contentUrl: '/app/player/IXoYAzKsI',
				imageUrl: '/_n/images/sleep-content/wonder.webp',
			},
			{
				contentTitle: messages.sleepSlide3Title,
				contentSubheading: messages.sleepSlide3Narrator,
				contentUrl: '/app/player/2QQEAZ7IsG',
				imageUrl: '/_n/images/sleep-content/dream-with-me.webp',
			},
			{
				contentTitle: messages.sleepSlide4Title,
				contentSubheading: messages.sleepSlide4Narrator,
				contentUrl: '/app/player/4kOrIzkAV',
				imageUrl: '/_n/images/sleep-content/the-nordland-night-train.webp',
			},
			{
				contentTitle: messages.sleepSlide5Title,
				contentSubheading: messages.sleepSlide5Narrator,
				contentUrl: '/app/player/eAqHaT2Fej',
				imageUrl: '/_n/images/sleep-content/journey-to-the-stars.webp',
			},
		],
	},
	stress: {
		title: messages.stressTab,
		navigateTo: '/app/meditate/stress',
		slides: [
			{
				contentTitle: messages.stressSlide1Title,
				contentSubheading: messages.stressSlide1Narrator,
				contentUrl: '/app/program/euLMnJXPGG',
				imageUrl: '/_n/images/stress-content/calming-anxiety.webp',
			},
			{
				contentTitle: messages.stressSlide2Title,
				contentSubheading: messages.stressSlide2Narrator,
				contentUrl: '/app/program/qK3IeqhiJP',
				imageUrl: '/_n/images/stress-content/7-days-of-calm.webp',
			},
			{
				contentTitle: messages.stressSlide3Title,
				contentUrl: '/app/player/9CvvX-oLYW',
				imageUrl: '/_n/images/stress-content/calm-island.webp',
			},
			{
				contentTitle: messages.stressSlide4Title,
				contentSubheading: messages.stressSlide4Narrator,
				contentUrl: '/app/program/NYdp8r6',
				imageUrl: '/_n/images/stress-content/letting-go-of-anxiety.webp',
			},
			{
				contentTitle: messages.stressSlide5Title,
				contentSubheading: messages.stressSlide5Narrator,
				contentUrl: '/app/program/KnHxHkKMmf',
				imageUrl: '/_n/images/stress-content/anxiety-release.webp',
			},
		],
	},
	focus: {
		title: messages.focusTab,
		navigateTo: '/app/meditate/focus',
		slides: [
			{
				contentTitle: messages.focusSlide1Title,
				contentSubheading: messages.focusSlide1Narrator,
				contentUrl: '/app/player/jTS7kkhCqn',
				imageUrl: '/_n/images/focus-content/infinite-lofi-for-focus.webp',
			},
			{
				contentTitle: messages.focusSlide2Title,
				contentSubheading: messages.focusSlide2Narrator,
				contentUrl: '/app/program/E-_HkbaeTU',
				imageUrl: '/_n/images/focus-content/silk-music-for-focus.webp',
			},
			{
				contentTitle: messages.focusSlide3Title,
				contentSubheading: messages.focusSlide3Narrator,
				contentUrl: '/app/program/n10_MRfMwr',
				imageUrl: '/_n/images/focus-content/deep-focus.webp',
			},
			{
				contentTitle: messages.focusSlide4Title,
				contentSubheading: messages.focusSlide4Narrator,
				contentUrl: '/app/program/BrSsa2FrOj',
				imageUrl: '/_n/images/focus-content/mau5trap.webp',
			},
			{
				contentTitle: messages.focusSlide5Title,
				contentSubheading: messages.focusSlide5Narrator,
				contentUrl: '/app/player/uvqyM--Byq',
				imageUrl: '/_n/images/focus-content/finding-focus.webp',
			},
		],
	},
	relaxation: {
		title: messages.relaxationTab,
		navigateTo: '/app/meditate/quick-meditations',
		slides: [
			{
				contentTitle: messages.relaxationSlide1Title,
				contentSubheading: messages.relaxationSlide1Narrator,
				contentUrl: '/app/player/OvdRFZxD74',
				imageUrl: '/_n/images/relaxation-content/infinite-ambient-for-relaxation.webp',
			},
			{
				contentTitle: messages.relaxationSlide2Title,
				contentSubheading: messages.relaxationSlide2Narrator,
				contentUrl: '/app/program/mGnSh1CiB2',
				imageUrl: '/_n/images/relaxation-content/deep-sleep-relax.webp',
			},
			{
				contentTitle: messages.relaxationSlide3Title,
				contentSubheading: messages.relaxationSlide3Narrator,
				contentUrl: '/app/program/DepP2jGMnc',
				imageUrl: '/_n/images/relaxation-content/midday-relaxation-break.webp',
			},
			{
				contentTitle: messages.relaxationSlide4Title,
				contentSubheading: messages.relaxationSlide4Narrator,
				contentUrl: '/app/player/rSKZ9fXz_h',
				imageUrl: '/_n/images/relaxation-content/breath-into-relaxation.webp',
			},
			{
				contentTitle: messages.relaxationSlide5Title,
				contentSubheading: messages.relaxationSlide5Narrator,
				contentUrl: '/app/program/7I4GMyHTtw',
				imageUrl: '/_n/images/relaxation-content/relaxing-harp-for-stress-relief.webp',
			},
		],
	},
	physicalWellbeing: {
		title: messages.physicalWellbeingTab,
		navigateTo: '/app/movement',
		slides: [
			{
				contentTitle: messages.physicalWellbeingSlide1Title,
				contentSubheading: messages.physicalWellbeingSlide1Narrator,
				contentUrl: '/app/player/xb2vKjQ_QU',
				imageUrl: '/_n/images/physical-wellbeing-content/jump-start-your-day.webp',
			},
			{
				contentTitle: messages.physicalWellbeingSlide2Title,
				contentSubheading: messages.physicalWellbeingSlide2Narrator,
				contentUrl: '/app/player/CmAULfYM72',
				imageUrl: '/_n/images/physical-wellbeing-content/releasing-physical-tension.webp',
			},
			{
				contentTitle: messages.physicalWellbeingSlide3Title,
				contentSubheading: messages.physicalWellbeingSlide3Narrator,
				contentUrl: '/app/player/r5elr-JRob',
				imageUrl: '/_n/images/physical-wellbeing-content/letting-go-of-the-past.webp',
			},
			{
				contentTitle: messages.physicalWellbeingSlide4Title,
				contentSubheading: messages.physicalWellbeingSlide4Narrator,
				contentUrl: '/app/player/lwmjCblGYl',
				imageUrl: '/_n/images/physical-wellbeing-content/meet-your-body.webp',
			},
			{
				contentTitle: messages.physicalWellbeingSlide5Title,
				contentSubheading: messages.physicalWellbeingSlide5Narrator,
				contentUrl: '/app/player/CV8FPMY4EE',
				imageUrl: '/_n/images/physical-wellbeing-content/releasing-physical-tension.webp',
			},
		],
	},
};
